"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROSE_COLOR_LIGHT = exports.PROSE_COLOR = exports.PROSE_LINE_HEIGHT_SMALL = exports.PROSE_FONT_SIZE_SMALL = exports.PROSE_LINE_HEIGHT = exports.PROSE_FONT_SIZE = exports.PROSE_FONT_WEIGHT = exports.PROSE_FONT_WEIGHT_BOLD = exports.PROSE_REGEX_MARKDOWN_BOLD = void 0;
const globalStyle_1 = __importDefault(require("../../style/globalStyle"));
exports.PROSE_REGEX_MARKDOWN_BOLD = /\*{2}(.*?)\*{2}/g;
exports.PROSE_FONT_WEIGHT_BOLD = 700;
exports.PROSE_FONT_WEIGHT = 400;
exports.PROSE_FONT_SIZE = 14;
exports.PROSE_LINE_HEIGHT = 1.5;
exports.PROSE_FONT_SIZE_SMALL = 11;
exports.PROSE_LINE_HEIGHT_SMALL = 1.36;
exports.PROSE_COLOR = globalStyle_1.default.grey1;
exports.PROSE_COLOR_LIGHT = globalStyle_1.default.grey2;
//# sourceMappingURL=constants.js.map